import dynamic from 'next/dynamic';

const LazyWhyCrehana = dynamic(() => import('./WhyCrehana'), {
  ssr: true,
});

export default LazyWhyCrehana;
